import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { Input, Button } from 'loyal-react'
import yn from 'yn'
export default class Form extends Component {
  constructor (props) {
    super(props)
    this.state = {
      addressType: 'Residencial',
      zipCode: this.props.address.zipCode || '',
      street: this.props.address.street || '',
      number: this.props.address.number || '',
      complement: this.props.address.complement || '',
      city: this.props.address.city || '',
      state: this.props.address.state || '',
      validators: {
        addressType: true,
        zipCode: true,
        street: true,
        number: true,
        complement: true,
        city: true,
        state: true
      }
    }

    this.save = this.save.bind(this)
    this.validate = this.validate.bind(this)
    this.handleField = this.handleField.bind(this)
  }

  validate () {
    let nextState = { ...this.state }
    nextState.validators.zipCode = !!this.state.zipCode
    nextState.validators.street = !!this.state.street
    nextState.validators.number = !!this.state.number
    nextState.validators.city = !!this.state.city
    nextState.validators.state = !!this.state.state
    this.setState({ nextState })

    return (
      nextState.validators.zipCode &&
      nextState.validators.street &&
      nextState.validators.number &&
      nextState.validators.city &&
      nextState.validators.state
    )
  }

  save () {
    if (this.validate()) {
      this.props.handleAddress({ ...this.state })
      this.props.handleStep(2)
    }
  }

  handleField (value, field) {
    this.setState({
      [field]: value,
      validators: { ...this.state.validators, [field]: !!value }
    })
  }

  render () {
    return (
      <Fragment>
        <div className='d-flex flex-column flex-wrap flex-md-row bg-ui-4 border-color-ui-3 border-bottom p-2'>
          <div className='col-12 col-md-6 p-0'>
            <div className='d-flex align-items-center'>
              <Input
                id='zipCode'
                label='CEP'
                className='col-12 mr-2 p-0 my-1'
                disabled={yn(this.props.address.zipCodeDisabled)}
                onChange={e => this.handleField(e.target.value, 'zipCode')}
                value={this.state.zipCode}
                mask={[/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]}
                valid={this.state.validators.zipCode}
              />
            </div>
            <div className='d-flex align-items-center'>
              <Input
                id='address'
                label='Endereço'
                className='col-12 p-0 my-1'
                onChange={e => this.handleField(e.target.value, 'street')}
                value={this.state.street}
                disabled={yn(this.props.address.streetDisabled)}
                valid={this.state.validators.street}
              />
            </div>
            <div className='d-flex justify-content-between'>
              <Input
                id='number'
                label='Número'
                className='col-4 p-0 my-1'
                value={this.state.number}
                onChange={e => this.handleField(e.target.value, 'number')}
                disabled={yn(this.props.address.numberDisabled)}
                valid={this.state.validators.number}
              />
              <Input
                id='complement'
                label='Complemento'
                className='col-7 p-0 my-1'
                value={this.state.complement}
                onChange={e => this.handleField(e.target.value, 'complement')}
                disabled={yn(this.props.address.complementDisabled)}
                valid={this.state.validators.complement}
              />
            </div>
            <div className='d-flex align-items-center'>
              <Input
                id='city'
                label='Cidade'
                className='col-12 p-0 my-1'
                value={this.state.city}
                onChange={e => this.handleField(e.target.value, 'city')}
                disabled={yn(this.props.address.cityDisabled)}
                valid={this.state.validators.city}
              />
            </div>
            <div className='d-flex align-items-center'>
              <Input
                id='state'
                label='Estado'
                className='col-12 p-0 my-1'
                value={this.state.state}
                onChange={e => this.handleField(e.target.value, 'state')}
                disabled={yn(this.props.address.stateDisabled)}
                valid={this.state.validators.state}
              />
            </div>
            <div className='d-flex align-items-center mt-2'>
              <Button
                id='save'
                className='btn btn-featured btn-icon txt-button txt-font-body'
                role='button'
                text='Próximo'
                onClick={this.save}
              />
            </div>
          </div>
          <div className='col-12 col-md-6 p-0 pl-md-2'>
            <div className='mt-2 bg-ui-3 p-2'>
              <p className='mb-2'>
                <strong>Previsão de entrega para esse endereço</strong>
              </p>
              {yn(process.env.REACT_APP_HAS_LIKE_PLUS_CUSTOM_MESSAGE)
                ? (
                  <p>Entrega em até 60 dias</p>
                ) : (
                  <p>Até {process.env.REACT_APP_DELIVERY_DAYS || '7'} dias úteis</p>
                )
              }
            </div>
            <div className='mt-1 bg-ui-3 p-2'>
              <p className='mb-2'>
                <strong>Instruções de recebimento</strong>
              </p>
              <p>
                Cadastre um endereço para a entrega do cartão
              </p>
              <p>
                Você receberá uma carta-berço registrada no endereço informado,
                contendo os seguintes itens:
              </p>
              <ul className='mt-2'>
                <li>• Seu Cartão Pré-pago Like Mais</li>
                <li>• Informações de desbloqueio e ativação</li>
                <li>• Instruções de uso</li>
                <li>• Telefone da Central de Atendimento Like Mais</li>
              </ul>
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

Form.propTypes = {
  address: PropTypes.object,
  handleAddress: PropTypes.func,
  handleStep: PropTypes.func
}



// WEBPACK FOOTER //
// ./src/features/LikePlusCustom/Tabs/RequestCard/Address/Form.js